module.exports = __webpack_public_path__ + "static/media/bowen-34.c902a1aa.jpg";